import { C15tConsent } from "cookiesConsent/infrastructure/c15t/consent/consentFromC15t"

const storageKey = `wb-consent`

interface PersistedConsentRecord {
  consents?: Record<string, boolean>
  consentInfo?: unknown
}

export class PersistedC15tConsentFactory {
  current = (): C15tConsent | null => {
    const raw = this.read()
    if (!raw) {
      return null
    } else {
      return this.parse(raw)
    }
  }

  private read = (): string | null => {
    try {
      return window.localStorage.getItem(storageKey)
    } catch {
      return null
    }
  }

  private parse = (raw: string): C15tConsent | null => {
    try {
      const record: PersistedConsentRecord = JSON.parse(raw)
      return {
        hasConsented: record.consentInfo != null,
        categories: record.consents || {}
      }
    } catch {
      return null
    }
  }
}

export const persistedC15tConsent = (): C15tConsent | null =>
  new PersistedC15tConsentFactory().current()
